/**
 * /eric — Today view (T-049, PR-27, PR-32, DES-08, US-15, US-22).
 *
 * Route config only. Component lives in eric.index.lazy.tsx (code-split).
 * No loader, beforeLoad, or validateSearch — the parent layout route
 * (eric.tsx) carries the operator guard for the whole /eric surface.
 */

import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/eric/')({});
